<app-text class="label">{{ label() | textTranslate: currentLanguage() }}</app-text>
